// Constant values are taken from:
// @wix/communities-blog-client-common/src/styles/variables.scss
// @wix/communities-blog-client-common/src/styles/breakpoints.scss
// Don't forget to update them there also
export const BREAKPOINT_POST_CONTENT_AREA_MIN = 746;
export const BREAKPOINT_POST_CONTENT_AREA_SMALL = 900;
